import classNames from 'classnames';
import { ThemeFile } from 'lib/context/ThemeContext';
import { ScreenTypes } from 'lib/utils/get-screen-type';

const getTabWidth = (screenType: ScreenTypes, tabLabelView: string) => {
  switch (screenType) {
    case 'sm':
      if (tabLabelView === 'long') {
        return '!w-[90vw]';
      }
    default:
      return 'w-auto';
  }
};

const isLongLabelView = (screenType: ScreenTypes, tabLabelView: string) => {
  return tabLabelView === 'long' && screenType === 'sm';
};

const getTabCommonClasses = (screenType: ScreenTypes, tabLabelView: string) => {
  if (isLongLabelView(screenType, tabLabelView)) {
    return '!text-s font-bold border-b-3 border-primary p-xs items-end';
  } else {
    return 'py-[10px] min-h-[44px]';
  }
};

const getSliderClasses = (screenType: ScreenTypes, tabLabelView: string) => {
  if (isLongLabelView(screenType, tabLabelView)) {
    return classNames(
      'pl-m [&_.slick-arrow]:!top-[-20px] border-white',
      '[&_.slick-prev]:!left-[10px] [&_.slick-next]:!right-[10px]',
      '[&_.slick-list]:pl-0 [&_.slick-list]:pr-0 [&_.slick-active]:!pr-m'
    );
  } else {
    return '[&_.slick-arrow]:!top-0 [&_.slick-prev]:!left-0 [&_.slick-next]:!right-0 text-light-black';
  }
};

const getTabButtonClasses = (screenType: ScreenTypes, tabLabelView: string) => {
  if (isLongLabelView(screenType, tabLabelView)) {
    return 'text-left h-full w-full pr-s';
  } else {
    return 'w-full h-full px-m flex items-center justify-center';
  }
};

const getSelectTabButtonTextWrapperClasses = (screenType: ScreenTypes, tabLabelView: string) => {
  if (isLongLabelView(screenType, tabLabelView)) {
    return '';
  } else {
    return 'inline-block border-b-3 border-primary';
  }
};

const getRbAArrowClasses = (screenType: ScreenTypes, tabLabelView: string) => {
  if (isLongLabelView(screenType, tabLabelView)) {
    return '';
  } else {
    return '!from-white !via-white/80 !to-white/10';
  }
};

const getActiveTabClasses = (screenType: ScreenTypes, tabLabelView: string) => {
  if (isLongLabelView(screenType, tabLabelView)) {
    return '';
  } else {
    return 'bg-black !text-white font-bold';
  }
};

const getTabContainerClasses = (screenType: ScreenTypes, tabLabelView: string) => {
  if (isLongLabelView(screenType, tabLabelView)) {
    return 'mb-6';
  } else {
    return '';
  }
};

export const CoveoTabsTheme = (screenType: ScreenTypes, tabLabelView: string): ThemeFile => {
  return {
    aw: {
      classes: {},
    },
    rba: {
      classes: {
        tabsContainer: classNames(
          'tabscontainer col-span-12 relative max-w-[100vw]',
          getTabContainerClasses(screenType, tabLabelView)
        ),
        slider: classNames(
          'coveo-tabs-slider relative bg-white text-body md:text-xs md:font-bold border-b border-gray max-md:mx-[calc(50%-50vw)] md:mx-0',
          '[&_.slick-list]:h-full max-md:[&_.slick-list]:pr-m [&_.slick-list]:overflow-hidden',
          '[&_.slick-track]:h-full [&_.slick-track]:flex [&_.slick-track]:items-stretch [&_.slick-track]:!ml-0 [&_.slick-track]:!mr-0 [&_.slick-track]:!justify-start',
          '[&_.slick-arrow]:!transform-none [&_.slick-arrow]:!h-full [&_.slick-arrow]:!flex [&_.slick-arrow]:!items-center',
          '[&_.slick-disabled]:!hidden',
          'max-md:[&_.slick-list]:pl-0',
          'max-md:[&_.slick-slide>div]:!w-auto max-md:[&_.slick-slide>div]:!inline-block max-md:[&_.slick-slide>div]:!flex',
          'max-md:[&_.slick-slide>div]:!h-full max-md:[&_.slick-slide]:!h-auto',
          '[&_.slick-slide:last-of-type_.tab]:before:!hidden',
          '[&_.slick-slide]:!flex [&_.slick-slide]:!items-stretch',
          '[&_.slick-slide>div]:!h-full [&_.slick-slide>div]:!flex',
          getSliderClasses(screenType, tabLabelView)
        ),
        tab: classNames(
          'tab !flex h-full items-center relative',
          !isLongLabelView(screenType, tabLabelView) &&
            'before:content-[""] before:absolute before:top-[6px] before:bottom-[6px] before:h-auto before:-translate-y-0 before:left-full before:w-[1px] before:bg-gray ',
          getTabWidth(screenType, tabLabelView),
          getTabCommonClasses(screenType, tabLabelView)
        ),
        activeTab: getActiveTabClasses(screenType, tabLabelView),
        tabButton: getTabButtonClasses(screenType, tabLabelView),
        activeTabButtonTextWrapper: getSelectTabButtonTextWrapperClasses(screenType, tabLabelView),
        tabs: {
          nextArrowClass: classNames(
            'flex items-center justify-center h-full w-[59px] z-10 !bg-gradient-to-l !justify-end md:pr-s pr-m',
            getRbAArrowClasses(screenType, tabLabelView)
          ),
          prevArrowClass: classNames(
            'flex items-center justify-center h-full w-[59px] z-10 !bg-gradient-to-r !justify-start pl-s',
            getRbAArrowClasses(screenType, tabLabelView)
          ),
        },
        numberedPaginationClass: 'text-right !font-xs font-semi-bold pt-xxs',
      },
    },
  };
};
